import ContentToolbar from './main.vue'

export * from './hooks'

export default ContentToolbar
